import {
    FEATURE__LOGGING,
    getFeature
} from '../utils/features';

export const shouldUseLogging = () => getFeature(FEATURE__LOGGING);

export const log = (level, ...args) => {
    if (shouldUseLogging() && typeof console !== 'undefined' && console[level]) {
        console[level]('%c AuctionLook \n', 'background: #222; color: #bada55', ...args);
    }
};
